<template>
  <div style="width: 100%; height: 100%; display: flex; overflow: hidden; min-height: 400px; padding: 0;">
    <!-- 左侧表格区域 -->
    <div style="flex: 1; flex-direction: column; overflow-y: hidden;">
      <!-- 搜索区域 -->
      <el-card shadow="never" class="search-card" style="width: 100%;">
        <el-form :model="form" label-position="left" label-width="60px" ref="formName" @submit.prevent>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="账号" prop="account">
                <el-input clearable v-model="form.account" placeholder="搜索账号" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="名称" prop="name">
                <el-input clearable v-model="form.name" placeholder="搜索名称" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="状态" prop="status">
                <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;">
                  <el-option label="正常" value="1" />
                  <el-option label="禁用" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="display: flex; align-items: center; justify-content: flex-end;">
              <el-form-item label=" " label-width="0">
                <div style="display: flex; gap: 8px;">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button @click="reset">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格卡片 -->
      <el-card shadow="never" class="table-card" style="width: 100%; flex: 1;">
        <template #header>
          <div class="table-header">
            <div class="table-header-left">
              <span style="font-size: 14px; font-weight: 500; color: #303133;">用户列表</span>
              <span v-if="roleId" style="font-size: 13px; color: #909399; margin-left: 12px;">
                当前筛选角色ID: {{ roleId }}
              </span>
            </div>
            <div class="table-header-right">
              <el-tooltip content="刷新" placement="bottom"><el-button circle @click="getData"><el-icon><Refresh /></el-icon></el-button></el-tooltip>
              <el-tooltip content="导出" placement="bottom"><el-button circle @click="handleExport"><el-icon><Download /></el-icon></el-button></el-tooltip>
              <el-tooltip content="打印" placement="bottom"><el-button circle @click="handlePrint"><el-icon><Printer /></el-icon></el-button></el-tooltip>
            </div>
          </div>
        </template>

        <el-table @row-click="clickrow" :data="tableData" border stripe :header-cell-style="stt" style="width: 100%">
          <el-table-column prop="account" label="账号" min-width="120" show-overflow-tooltip />
          <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" min-width="100" align="center">
            <template #default="{ row }">
              <el-tag v-if="row.status == 1" type="success">正常</el-tag>
              <el-tag v-if="row.status == 0" type="danger">禁用</el-tag>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper">
          <el-pagination
            @current-change="pageChange"
            v-model:current-page="page.current"
            :page-size="page.pageSize"
            :total="page.total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="onPageSizeChange"
          />
        </div>
      </el-card>
    </div>

    <!-- 右侧权限面板 -->
    <div v-if="current.id" style="height: 100%; width: 35%; padding: 15px; border-left: 1px solid #e5e5e5; margin-left: 15px; display: flex; flex-direction: column;">
      <div style="margin-bottom: 5px; display: flex; align-items: center; border-bottom: 1px solid #e1e1e1; padding-bottom: 15px; width: 100%; justify-content: space-between;">
        <div style="display: flex; align-items: center;">
          <el-avatar size="small" :src="$store.state.common.systemInfo.fileurl + current.avatar" />
          <div style="margin-left: 5px; font-size: 14px; font-weight: bold;">{{ current.name }}</div>
        </div>
        <div style="display: flex; gap: 8px;">
          <el-button @click="closePanel" size="default" round>取消</el-button>
          <el-button v-if="$hasPermission('btn:save_auth')" @click="saveauth" type="primary" size="default" round :loading="saving">保存权限</el-button>
        </div>
      </div>

      <!-- 全选/全不选按钮 -->
      <div style="margin: 8px 0 12px 0; display: flex; gap: 8px;">
        <el-button size="small" @click="selectAll">全选</el-button>
        <el-button size="small" @click="selectNone">全不选</el-button>
        <span style="flex:1;"></span>
        <span style="font-size:12px; color:#909399;">已选 {{ authlist.length }} / {{ permissionOptions.length }}</span>
      </div>

      <div style="flex: 1; overflow-y: auto; padding: 10px; width: 100%; border-top: 1px solid #f0f0f0;">
        <el-checkbox-group v-model="authlist" style="display: flex; flex-direction: column;">
          <el-checkbox
            v-for="item in permissionOptions"
            :key="item.code"
            :label="item.code"
            style="margin: 3px;"
          >
            {{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { pub } from '../../../common/event';
import { mapState } from "vuex";
import { Plus, Refresh, Download, Printer } from '@element-plus/icons-vue';

export default {
  name: 'AccountAuthTableView',
  components: { Plus, Refresh, Download, Printer },
  data() {
    return {
      current: {},
      form: {},
      tableData: [],
      authlist: [],
      saving: false,
      page: { current: 1, pageSize: 15, total: 15 },
      stt: { background: "#209cd111", color: "#209cd1" },
      roleId: null,
      permissionOptions: [],
      permissionTreeData: [], // 存储树结构用于后续可能的操作
    };
  },
  mounted() {
    this.roleId = this.$route.query.role_id || null;
    this.loadAllPermissions();
    this.resetPanel();
    this.getData();
  },
  methods: {
    // 加载所有可用权限
    async loadAllPermissions() {
      try {
        const ret = await this.$r.get(`account/account/permissions/list`);
        if (ret && ret.success) {
          this.permissionTreeData = ret.data.tree || [];
          this.permissionOptions = this.flattenTree(this.permissionTreeData);
        }
      } catch (e) {
        console.error('加载权限列表失败', e);
        this.permissionOptions = [];
      }
    },
    // 将树形权限扁平化
    flattenTree(tree, result = []) {
      tree.forEach(node => {
        result.push({ code: node.code, name: node.name, id: node.id });
        if (node.children && node.children.length) {
          this.flattenTree(node.children, result);
        }
      });
      return result;
    },
    // 全选
    selectAll() {
      this.authlist = this.permissionOptions.map(item => item.code);
    },
    // 全不选
    selectNone() {
      this.authlist = [];
    },

    resetPanel() { this.current = {}; this.authlist = []; },
    closePanel() { this.resetPanel(); },
    filterWhere() {
      const whereform = { ...this.form };
      if (this.roleId) {
        whereform.role_id = this.roleId;
      }
      for (let k in whereform) {
        if (!whereform[k]) delete whereform[k];
      }
      return { current: this.page.current, pageSize: this.page.pageSize, ...whereform };
    },
    clickrow(row) {
      if (this.current.id === row.id) { this.resetPanel(); return; }
      this.current = row;
      this.loadAuth(row.id);
    },
    async loadAuth(userId) {
      try {
        const ret = await this.$r.get(`account/account/account/auth/${userId}`);
        if (ret.success) {
          let rawData = ret.data || [];
          if (Array.isArray(rawData) && rawData.length > 0 && typeof rawData[0] === 'number') {
            const codeMap = this.permissionOptions.reduce((map, item) => { if (item.id) map[item.id] = item.code; return map; }, {});
            this.authlist = rawData.map(id => codeMap[id] || id).filter(Boolean);
          } else {
            this.authlist = rawData;
          }
        } else { this.authlist = []; }
      } catch (error) {
        console.error('加载权限失败', error);
        this.authlist = [];
      }
    },
    async getData() {
      const where = this.filterWhere();
      const ret = await this.$api.account.page(where);
      if (ret && ret.success) {
        this.tableData = ret.data.data.filter(e => e.id > 1);
        this.page.total = ret.data.total;
        this.page.current = ret.data.page.current;
        this.page.pageSize = ret.data.page.pageSize;
      }
    },
    pageChange(e) { this.page.current = e; this.getData(); },
    onPageSizeChange(e) { this.page.pageSize = e; this.page.current = 1; this.getData(); },
    reset() { this.form = {}; this.$refs.formName?.resetFields(); this.getData(); },
    search() { this.page.current = 1; this.getData(); },
    async saveauth() {
      if (!this.current.id) return;
      // 直接保存用户勾选的code数组，不补全父级
      this.saving = true;
      try {
        const ret = await this.$r.put(`account/account/accountandauth`, { id: this.current.id, data: this.authlist });
        if (ret.success) {
          pub("success_message", "权限保存成功");
          await this.loadAuth(this.current.id);
          const loginUser = this.$store.state.user.user;
          if (loginUser && loginUser.id === this.current.id) {
            this.$store.dispatch({ type: `user/getUserAuth`, payload: {} });
          }
        } else {
          pub("error_message", ret.message || "保存失败");
        }
      } catch (error) {
        console.error('保存权限失败', error);
        pub("error_message", "请求失败，请重试");
      } finally {
        this.saving = false;
      }
    },
    handleExport() { this.$message.info('导出功能开发中'); },
    handlePrint() { window.print(); },
  }
};
</script>

<style scoped>
.search-card { margin-bottom: 16px; }
.search-card .el-form-item { margin-bottom: 0; }
.table-card :deep(.el-card__header) { padding: 10px 16px; border-bottom: 1px solid #e4e7ed; }
.table-header { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.table-header-left { display: flex; align-items: center; gap: 8px; }
.table-header-right { display: flex; align-items: center; gap: 4px; }
.pagination-wrapper { display: flex; justify-content: center; margin-top: 16px; width: 100%; }
</style>